module.exports = __webpack_public_path__ + "static/media/header.115528c4.jpg";